const statuses = {
  READY: 'ready',
  FAILED: 'failed',
  DISABLING: 'disabling',
  DISABLED: 'disabled',
  DELETING: 'deleting',
  PENDING: 'pending',
};

const serviceNames = {
  image: 'image',
  videoPackager: 'video-packager',
  file: 'file',
};

const defaultServices = {
  video: {
    name: serviceNames.videoPackager,
    instanceType: 'custom-4-7424',
    minimumInstanceNumber: 1,
    maximumInstanceNumber: 2,
  },
  image: {
    name: serviceNames.image,
    instanceType: 'custom-2-10240',
    minimumInstanceNumber: 1,
    maximumInstanceNumber: 2,
  },
};

export { defaultServices, serviceNames, statuses };
